import UniversalVideoRecorder from './app/App';

// Named export rather than default to avoid CommonJS issues as described here: https://rollupjs.org/guide/en/#outputexports
export { UniversalVideoRecorder };
